var r="4.8.10";export{r as version};
//# sourceMappingURL=package.json.js.map
